import script from "./SignUpFields.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpFields.vue?vue&type=script&setup=true&lang=js"

import "./SignUpFields.vue?vue&type=style&index=0&id=3e062afe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e062afe"]])

export default __exports__